import React, { useCallback, useState } from "react";
import {
  CircularProgress,
  List,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { connect } from "react-redux";
import * as actions from "../../actions";
import * as ru from "../../util/reportUtils";
import { PageItem } from "../../custom/Page";
import { useEffect } from "react";
import { FormattedMessage } from "react-intl";
import UserListItem from "./Reports/ReportManagersAndAgents/UserListItem";

export const TOGGLE_ALL_ENUM = {
  open: "openAll",
  close: "closeAll",
};

const useStyles = makeStyles((theme) => ({
  mainHeaderRow: {
    "& > th": {
      borderBottom: "3px solid #333",
      color: "#AAA",
    },
  },
  mainRow: {
    "& > *": {
      borderBottom: "unset",
    },
    "& > td:first-child": {
      width: 10,
      paddingLeft: 10,
      paddingRight: 0,
    },
  },
  detailBox: {
    backgroundColor: "#151515",
    paddingLeft: 50,
  },
  detailHeaderRow: {
    "& > th": {
      borderBottom: "3px solid #222",
      color: "#AAA",
    },
  },
  detailRow: {
    "& > td": { borderBottom: "1px solid #222" },
  },
  iconManager: {
    color: theme.palette.primary.main,
  },
  iconAgent: {
    color: "white",
  },
  iconCustomer: {
    color: "#666",
  },
  listTitle: {
    color: "#999",
    paddingLeft: 16,
  },
  contractCount: {
    color: theme.palette.primary.main,
  },
}));

const UserHierarchy = ({
  currentUser,
  getConfig,
  enableHeader = true,
  enableInfoValues = true,
  userId,
  isRoot,
}) => {
  const [loading, setLoading] = useState(true);
  const [simpleCurrentUser, setSimpleCurrentUser] = useState({});
  const [user, setUser] = useState({
    managers: [],
    agents: [],
    customers: [],
    contracts: [],
    received: {},
    ui: {
      isListOpen: false,
    },
  });
  const classes = useStyles();

  const getReport = useCallback(async () => {
    setLoading(true);

    const simpleCurrentUser = await ru.simplifyUser(
      JSON.parse(JSON.stringify(currentUser)),
      [],
      null
    );

    const user = await actions.getUserHierarchy();
    setUser(user);

    setSimpleCurrentUser(simpleCurrentUser);
    setLoading(false);
  }, [currentUser]);

  useEffect(() => {
    const fetchData = async () => {
      await getConfig();
      await getReport();
    };

    fetchData();
  }, [getConfig, getReport]);

  if (loading)
    return (
      <div style={{ width: "100%", textAlign: "center" }}>
        <CircularProgress style={{ marginTop: !enableHeader ? "5%" : "25%" }} />
      </div>
    );

  return (
    <PageItem>
      {enableHeader && (
        <Typography variant="subtitle1" align="center">
          <FormattedMessage id="app.hierarchy.below" />
        </Typography>
      )}
      <List>
        <UserListItem
          currentUser={simpleCurrentUser}
          user={user}
          classes={classes}
          toggleAll
          enableInfoValues={enableInfoValues}
          isRoot={isRoot}
        />
      </List>
    </PageItem>
  );
};

export default connect(
  (state) => ({ currentUser: state.user.user.me, config: state.config }),
  actions
)(UserHierarchy);
